import {isNullOrUndefined} from "../../../services/Validator";
import GlossaryLetterItem from "../../items/glossaryScreen/GlossaryLetterItem";

export default function GlossaryLettersList({terms, filteredTerms, scrollToLetter}) {
    // Used in GlossaryContent as a shortcut to specific letter related content

    // BUILD
    if (isNullOrUndefined(terms) || isNullOrUndefined(scrollToLetter))
        return null
    return (
        <div className="w-full flex justify-start space-x-[4px] mt-[12px]">
            {Object.keys(!isNullOrUndefined(filteredTerms) ? filteredTerms : terms).map((letter) => (
                <GlossaryLetterItem key={letter}
                                    letter={letter}
                                    scrollToLetter={() => scrollToLetter(letter)} />
            ))}
        </div>
    );
}